import { render, staticRenderFns } from "./AgendaAdama.vue?vue&type=template&id=05b7d5bd&scoped=true&"
import script from "./AgendaAdama.vue?vue&type=script&lang=js&"
export * from "./AgendaAdama.vue?vue&type=script&lang=js&"
import style0 from "./AgendaAdama.vue?vue&type=style&index=0&id=05b7d5bd&prod&scoped=true&lang=scss&"
import style1 from "./AgendaAdama.vue?vue&type=style&index=1&id=05b7d5bd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b7d5bd",
  null
  
)

export default component.exports